export default function cleanPermissionName(permission) {
  switch (permission) {
    case "admin":
      return "Admin"
    case "read-only":
      return "Read Only"
    case "super":
      return "Super"
    default:
      return ""
  }
}
